import * as yup from 'yup';

const LOGIN_SCHEMA = yup.object({
	email: yup.string().required().default('tdmanager@mailinator.com'),
	password: yup.string().required().default('test@123')
})

export { LOGIN_SCHEMA }